import { ReactNode } from 'react';

type DetailRowProps = {
  label: string;
  children: ReactNode;
  /** Medium-weight label, used for key rows like Status and Order ID. */
  emphasizeLabel?: boolean;
  /** Right-align and allow wrapping for long values such as notes. */
  wrapValue?: boolean;
};

const DetailRow = ({
  label,
  children,
  emphasizeLabel = false,
  wrapValue = false
}: DetailRowProps) => (
  <div
    className={`flex items-center justify-between ${wrapValue ? 'gap-2' : ''}`}
  >
    <div
      className={`text-sm text-cofeeNeutral8 ${
        emphasizeLabel ? 'font-medium' : 'font-normal'
      } ${wrapValue ? 'shrink-0' : ''}`}
    >
      {label}
    </div>
    <div
      className={`text-sm font-normal text-cofeeNeutral10 ${
        wrapValue ? 'min-w-0 text-right' : ''
      }`}
    >
      {children}
    </div>
  </div>
);

export default DetailRow;
